import { InvestmentTypeEnum, BookingTypeEnum } from "@bn/api/apiv1";
import { toGermanNumberFormat } from "./numberFormat";

export interface GetNumberOfLotsByInvestmentAndBookingType {
  value: number;
  investmentType: InvestmentTypeEnum;
  bookingType: BookingTypeEnum;
}

export const getNumberOfLotsByInvestmentAndBookingType = ({
  value,
  bookingType,
}: GetNumberOfLotsByInvestmentAndBookingType): string => {
  const formattedValue = toGermanNumberFormat(value, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });

  if (bookingType === "split") {
    return `1:${formattedValue}`;
  }
  if (bookingType === "reverse_split") {
    return `${formattedValue}:1`;
  }

  if (bookingType === "dividend" || bookingType === "purchase_right") return "";

  return `${formattedValue} x`;
};
